import React from 'react';
import { ledetekst } from '../diverse/Ledetekst.js';

interface Props {
	children?: React.ReactNode;
	skalMaskeres?: boolean;
	verdi?: React.ReactNode;
	className?: string;
}

function VerdiEllerInfoMangler(props: Props) {
	const { children, skalMaskeres = false, verdi } = props;
	const faktiskVerdi = children || verdi;

	if (!!faktiskVerdi) {
		return (
			<span
				{...(!!skalMaskeres ? { 'data-hj-suppress': true } : {})}
				className={props.className}
			>
				{faktiskVerdi}
			</span>
		);
	} else {
		return (
			<span className="info-mangler">
				{ledetekst.getTekst(
					'arbeidsvarsling.frontendkomponenter.infomangler'
				)}
			</span>
		);
	}
}

export { VerdiEllerInfoMangler };
